export const MAP_CENTER = [44.856214, 38.006471]

export const ymapSettings = {
  apiKey: process.env.VUE_APP_YANDEX_MAPS,
  lang: 'ru_RU',
  coordorder: 'latlong',
  version: '2.1',
}

export const options = [
  { id: -1, label: 'Все' },
  { id: 0, label: 'Отклик' },
  { id: 1, label: 'Выгрузился' },
  { id: 2, label: 'Погрузился' },
]

export const balloonLayout = [
  '<div class="my-balloon-zerno">' +
    '<a class="close-balloon-zerno" href="#">&times;</a>' +
    '<b>Маршрут на автомобиле<br /></b><br />' +
    'Расстояние: ' +
    '<i>{{ properties.distance.text }}</i>,<br />' +
    'Время в пути: ' +
    '<i>{{ properties.duration.text }} (без учета пробок) </i>' +
    '</div>',
  {
    build() {
      this.constructor.superclass.build.call(this)
      this._$element = document.querySelector('.close-balloon-zerno')
      this._$element.addEventListener('click', this.onCloseClick.bind(this))
    },
    onCloseClick(e) {
      e.preventDefault()
      this.events.fire('userclose')
    },
  },
]

export const multiRouteOptions = (
  referencePoints,
  balloonLayout,
  results = 1,
) => [
  { referencePoints, params: { results } },
  {
    routeActiveStrokeColor: 'ff0000',
    wayPointStartIconLayout: 'default#image',
    wayPointFinishIconLayout: 'default#image',
    wayPointStartIconImageHref: require('@/assets/img/rectangleLoad.svg'),
    wayPointFinishIconImageHref: require('@/assets/img/rectangleUnload.svg'),
    balloonPanelMaxMapArea: 0,
    editorDrawOver: false,
    pinVisible: false,
    boundsAutoApply: true,
    balloonLayout: true,
  },
]

export const clusterOptions = {
  cluster: {
    preset: 'islands#redClusterIcons',
    gridSize: 128,
    hasBalloon: false,
    hasHint: false,
    clusterZIndexHover: 700,
  },
}
export const clusterBidsOptions = {
  cluster: {
    preset: 'islands#redClusterIcons',
    gridSize: 128,
    hasHint: false,
    clusterZIndexHover: 700,
    clusterBalloonMaxHeight: 460,
    clusterBalloonLayout: [
      '<div class="calc-cluster-balloon customBalloon">',
      '{% for geoObject in properties.geoObjects %}',
      '<div class=ballon_body>{{ geoObject.properties.balloonContentBody|raw }}</div>',
      '{% endfor %}',
      '</div>',
    ].join(''),
    clusterDisableClickZoom: true,
    clusterOpenBalloonOnClick: true,
    clusterIcons: [
      {
        href: require('@/assets/img/sandX.svg'),
        size: [60, 65],
        offset: [-35, -65],
        contentOffset: [0, 0],
      },
    ],
  },
}

export const clusterOptionsCalc = {
  cluster: {
    preset: 'islands#redClusterIcons',
    gridSize: 128,
    hasHint: false,
    clusterDisableClickZoom: true,
    clusterOpenBalloonOnClick: true,
    clusterZIndexHover: 700,
    clusterBalloonMaxHeight: 280,
    clusterBalloonLayout: [
      '<div class="calc-cluster-balloon">',
      '{% for geoObject in properties.geoObjects %}',
      '<div class=ballon_body>{{ geoObject.properties.balloonContentBody|raw }}</div>',
      '{% endfor %}',
      '</div>',
    ].join(''),
  },
}

export const colors = { 0: 'ym-yellow', 1: 'ym-green', 2: 'ym-red' }

export const markerIcon = {
  layout: 'default#imageWithContent',
  imageHref: '',
  imageSize: [35, 20],
  imageOffset: [0, 0],
  contentOffset: [-10, -15],
}

const markerStyle =
  'color:#ff0000;font-weight:bold;white-space:nowrap;font-size:12px'

export const markerIconDesktop = {
  layout: 'default#imageWithContent',
  imageHref: require('@/assets/img/red_truck_big.svg'),
  imageSize: [35, 20],
  imageOffset: [0, 0],
  contentOffset: [-10, -15],
  contentLayout: `<div style="${markerStyle}">$[properties.iconContent]</div>`,
}

export const markerCalcIcon = {
  layout: 'default#imageWithContent',
  imageHref: require('@/assets/img/rectangleLoad.svg'),
  imageSize: [40, 45],
  imageOffset: [-20, -45],
  contentOffset: [-25, -15],
}

export const markerSandIcon = {
  layout: 'default#imageWithContent',
  imageHref: require('@/assets/img/sand.svg'),
  imageSize: [50, 65],
  imageOffset: [-24, -65],
  contentOffset: [-25, -15],
}

export const clusterBidsOptionsHome = {
  cluster: {
    preset: 'islands#redClusterIcons',
    gridSize: 128,
    hasHint: false,
    clusterZIndexHover: 700,
    clusterBalloonMaxHeight: 460,
    clusterBalloonLayout: [
      '<div class="calc-cluster-balloon customBalloon">',
      '{% for geoObject in properties.geoObjects %}',
      '<div class=ballon_body>{{ geoObject.properties.balloonContentBody|raw }}</div>',
      '{% endfor %}',
      '</div>',
    ].join(''),
    clusterDisableClickZoom: true,
    clusterOpenBalloonOnClick: false,
    clusterIcons: [
      {
        href: require('@/assets/img/sandX.svg'),
        size: [60, 65],
        offset: [-35, -65],
        contentOffset: [0, 0],
      },
    ],
  },
}
